import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import { withSuperJSONPage as _withSuperJSONPage } from "babel-plugin-superjson-next/tools";
import { JobSeekersPage } from "styles/jss/JobSeekers.styles";
import GetQueryHoc from "components/HOCs/GetQueryHOC";
import { getJobSeekers } from "services/jobSeekers.api";
import JobSeekGuidBox from "components/PagesComponents/JobSeeker/JobSeekGuidBox";
import JobSeekRecruitmentProcess from "components/PagesComponents/JobSeeker/JobSeekRecruitmentProcess";
var JobSeekers = function() {
    return /*#__PURE__*/ _jsxs(JobSeekersPage, {
        children: [
            /*#__PURE__*/ _jsx(JobSeekGuidBox, {}),
            /*#__PURE__*/ _jsx(JobSeekRecruitmentProcess, {})
        ]
    });
};
export var __N_SSG = true;
export default _withSuperJSONPage(GetQueryHoc(JobSeekers, {
    pageTitle: "jobSeekers.page-title",
    cacheKey: "jobSeekers-page",
    apiCall: getJobSeekers,
    apiOptions: {
        onError: function() {
            return console.log("info is empty");
        }
    }
}));
